module.exports = __webpack_public_path__ + "img/Man-9.f78a5e3b.svg";